import { compose } from 'recompose';

import VariantsFilter from './VariantsFilter';

const enhance = compose();

export default enhance(VariantsFilter);
